import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25ae3bc7"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Reload ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EventStateSpinner = _resolveComponent("EventStateSpinner")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_PageWrapper = _resolveComponent("PageWrapper")!

  return (_openBlock(), _createBlock(_component_PageWrapper, null, {
    "content-center": _withCtx(() => [
      _createVNode(_component_EventStateSpinner, {
        isLoading: _ctx.isLoadingState,
        showFailureState: _ctx.isError,
        loadingTitle: "Loading...",
        failureTitle: "Error connecting to server"
      }, null, 8, ["isLoading", "showFailureState"]),
      (_ctx.isError)
        ? (_openBlock(), _createBlock(_component_BaseButton, {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.reload())),
            pattern: _ctx.ButtonColorPattern.FILL,
            color: _ctx.ButtonColor.PRIMARY
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["pattern", "color"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}